import React from 'react';
import bilLoaderAnimation from '../../resources/images/bil-loader.gif';
import './styles.less';

const Loader = () => (
    <div className="bil-loader">
        <img src={bilLoaderAnimation} alt="icon" />
    </div>
);

export default Loader;
